import { CategoriasStringServer } from "./Articles";
import { UserDataPerfil } from "./User";


export const DIAS_VENTA_CADUCADA = 7; // Número de días para considerar una venta como caducada después de la compra. (Ejemplo: Si el comprador no recoge el artículo en 7 días, se considera caducada y el vendedor puede reclamar el dinero).

export enum EstadosCompraBeseif {
    PAGADO = "pagado",
    CANCELADO = "cancelado",
    ENTREGADO = "entregado",
    FINALIZADO = "finalizado",
    ACEPTADO = "aceptado",
    DEVOLUCION = "devolucion",
    RECOGIDO = "recogido",
    INCIDENCIA = "incidencia"
}

export const EstadosBeseifFinalizacion = [EstadosCompraBeseif.FINALIZADO];

export enum TipoBeseif {
    COMPRA = "COMPRA",
    MIS_TRANSACCIONES = "MIS_TRANSACCIONES",
}

export interface PostBeseifObj {
    id_user: number;
}

export interface GetCodigoBeseif {
    codigo: string;
}

export interface GetTokenBeseif {
    token_type: string;
    access_token: string;
}


export interface GetMisTransaccionesBeseif {
    id_user: number;
    email_usuario: string;
}

export interface GetProcesoCompraBeseif {
    id_user: number;
    email_vendedor: string;
    email_comprador: string;
    nombre_articulo: string;
    precio_articulo: string;
    id_anuncio: number;
    categoria_articulo: string;
}

export interface ObtenerLibroPagadoBeseif {
    id_user: number;
    id_libro: number;
    categoria_libro: CategoriasStringServer;
}

export enum ModoComprasMenu {
    GENERAL = "GENERAL",
    SEGUIMIENTO = "SEGUIMIENTO"
}

export enum ModeCompraBeseif {
    COMPRAS = "compras",
    VENTAS = "ventas"
}

export interface EstadoBeseifCompra {
    id: number;
    accion: EstadosCompraBeseif;
    fecha_recogida?: string;
    timestamp: string;
}

export interface GetArticuloCompraBeseif {
    id: number;
    id_articulo: number;
    categoria: string;
    imagen?: string;
    titulo: string;
    precio: number;
    moneda: string;
    vendedor: UserDataPerfil;
    comprador: UserDataPerfil;
    id_transaccion: string;
    accion: EstadosCompraBeseif;
    fecha_recogida?: string;
    comprado: boolean;
    fecha_compra: string;
}